import Vue from 'vue';

// Library and theme styles come first so component styles can override them.
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/lib/mdbvue.css';
// mdbIcon only renders classes: the solid and brands icon fonts come from here.
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/brands.min.css';
import './styles/theme.scss';

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

// Laravel renders every page and embeds its data and copy; the app starts from that, so the first
// load needs no request. Without it (the dev server, the static shell) the views fetch as before.
// eslint-disable-next-line no-underscore-dangle
const preloaded = window.__INTRO__;

if (preloaded) {
  i18n.mergeLocaleMessage('nl', preloaded.messages);
  store.commit('intro/HYDRATE', preloaded);
  document.documentElement.classList.add('pentagon-ssr');
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
